import styled from '@emotion/styled/macro';

export const StyledContainer = styled.div`
  margin-bottom: 10px;
  & > * {
    margin-bottom: 10px;
  }
`;
